var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Box from "./Box";
import { ARROW_RIGHT_SVG } from "../assets";
import { messages } from "../messages";
import { displayDate } from "../util/date";
var CuratedListView = /** @class */ (function (_super) {
    __extends(CuratedListView, _super);
    function CuratedListView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            viewAll: false,
            hasMoreContent: true
        };
        return _this;
    }
    Object.defineProperty(CuratedListView.prototype, "listview", {
        get: function () {
            return this._listview;
        },
        set: function (val) {
            this._listview = val;
            if (val) {
                var hasMoreContent = Math.abs(val.scrollHeight - val.clientHeight) > 40;
                if (this.state.hasMoreContent != hasMoreContent) {
                    this.setState({ hasMoreContent: hasMoreContent });
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    CuratedListView.prototype.componentDidMount = function () {
    };
    CuratedListView.prototype.render = function () {
        var _this = this;
        var _a = this.props, sets = _a.sets, hideUpdated = _a.hideUpdated;
        return React.createElement("div", { style: this.props.style, className: this.props.className },
            React.createElement(Box, { className: "curated-container" },
                React.createElement("div", { className: "top" },
                    React.createElement("h3", { className: "set-title" }, this.props.title),
                    React.createElement("div", { className: 'view-all-container', style: !this.state.hasMoreContent ? { display: 'none' } : {} },
                        React.createElement("a", { href: "javascript:void(0)", onClick: function () {
                                _this.setState({ viewAll: !_this.state.viewAll });
                            } },
                            React.createElement("span", null,
                                this.state.viewAll ? messages.Hide : messages.ViewAll,
                                " ",
                                React.createElement("img", { src: ARROW_RIGHT_SVG, height: 17 }))))),
                React.createElement("div", { className: "curated-listview-container" },
                    React.createElement("ul", { ref: function (ref) { return _this.listview = ref; }, className: "curated-listview " + (this.state.viewAll ? 'all' : ''), style: (this.listview && this.state.viewAll) ? { maxHeight: this.listview.scrollHeight + "px" } : {} }, sets.map(function (s, i) {
                        return React.createElement("li", { className: "set", key: i, onClick: function (e) {
                                _this.props.onClick && _this.props.onClick(s);
                            } },
                            React.createElement("div", { className: "set-img" },
                                React.createElement("img", { src: s.image_url })),
                            React.createElement("div", { className: "set-description" },
                                React.createElement("div", { className: "set-title" }, s.title),
                                React.createElement("div", { className: "set-curator" }, s.subtitle),
                                !hideUpdated && React.createElement("div", { className: "set-updated" },
                                    "Updated ",
                                    displayDate(s.updated_at))));
                    })))));
    };
    return CuratedListView;
}(React.PureComponent));
export default CuratedListView;
//# sourceMappingURL=CuratedListView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/CuratedListView.js
// module id = 1164
// module chunks = 0